import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgInboxOut = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M19.313 14.244h-3.375c-.32 0-.613.18-.755.467l-.89 1.783H9.707l-.892-1.783a.84.84 0 0 0-.754-.467H4.126c-.621 0-1.125.504-1.125 1.125v3.375a2.25 2.25 0 0 0 2.25 2.25h13.5a2.25 2.25 0 0 0 2.25-2.25V15.93c0-.931-.756-1.687-1.687-1.687m0 4.5c0 .31-.253.562-.563.562H5.25a.563.563 0 0 1-.562-.562V15.93H7.54l.892 1.784a.84.84 0 0 0 .755.466h5.624c.32 0 .613-.18.755-.466l.89-1.784h2.855zM8.963 8.348l2.193-2.361V13.4a.844.844 0 0 0 1.688 0V5.987l2.194 2.363a.843.843 0 1 0 1.237-1.15l-3.657-3.937a.873.873 0 0 0-1.237 0L7.725 7.2a.843.843 0 1 0 1.238 1.148"
    }));
export default SvgInboxOut;
